export default "__VITE_ASSET__808492d0__"